export enum Keys {
  // Movement with the W S D A keys
  KEY_W = 'KeyW',
  KEY_A = 'KeyA',
  KEY_S = 'KeyS',
  KEY_D = 'KeyD',

  // A: Also used for rtc Audio stats
  // V: Used for rtc Video stats
  KEY_L = 'KeyL',
  KEY_M = 'KeyM',
  KEY_V = 'KeyV',

  // Movement with the Arrows
  KEY_RIGHT = 'ArrowRight',
  KEY_LEFT = 'ArrowLeft',
  KEY_UP = 'ArrowUp',
  KEY_DOWN = 'ArrowDown',

  KEY_SPACE = 'Space',
  KEY_ENTER = 'Enter',
}
